<template>
  <div class="login">
    <div style="width:100%;text-align:center;">
      <!-- <b-card title="Store and Share Decentralized Maps" style="width:90%;border-radius:15px">
        
        <b-card-body>
          <b-card-img src="https://cdn.pixabay.com/photo/2018/05/17/16/03/compass-3408928_1280.jpg" style="border-radius:15px;" class="" />
        </b-card-body>
      </b-card> -->
      <b-card title="" style="width:90%;border-radius:15px"  class="overflow-hidden">
        <h1>Create and share your maps for your events, business or personal use.</h1>
        <b-card-body>
          <b-card-text>
            <em>Maps</em> gives you a beautiful page to share maps with a description and placemarks that you specify. If you decide to share a link to the map, the user will be able to get directions easily to any of the placemarks.
          </b-card-text>
          
          <h3 class="mt-4">What kind of maps will you make?</h3>
          <!-- <b-card-text>
            Check out the samples below:
          </b-card-text> -->
        </b-card-body>
        <b-list-group flush>
            <b-list-group-item>
              <h4>Personal Maps</h4>
              <a href="https://www.cabinetmaps.com/shared/somerville.id.blockstack/1649afe8-414d-4678-b483-3511e414df0b" target="_blank">Maritime Museums I've Visited</a>
            </b-list-group-item>
            <b-list-group-item>
              <h4>Business Maps</h4>
              <a href="https://www.cabinetmaps.com/shared/thewilliam.id.blockstack/c07437e4-fe7e-4f5c-832a-e2a3fc984b65" target="_blank">Boston Area Surf Shops</a>
            </b-list-group-item>
            <b-list-group-item>
              <h4>Event Maps</h4>
              <a href="https://www.cabinetmaps.com/shared/thewilliam.id.blockstack/506f14a0-22eb-4589-9146-2a34b9a5be3f" target="_blank">Tokyo Dance Conference</a>
            </b-list-group-item>
          </b-list-group>

        <b-card-img src="https://cdn.pixabay.com/photo/2018/05/17/16/03/compass-3408928_1280.jpg" style="border-radius:15px;width:50%;padding:10px" class="mt-4" alt="Image" left></b-card-img>
      </b-card>
      <h2 style="color:white" class="m-5">Try it today!</h2>
      <b-button class="fe-pulse-w-pause" variant="light" @click="signIn">Sign in with Blockstack</b-button>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields([
      'blockstack.user',
      'blockstack.userSession',
      'blockstack.user.username'
    ]),
  },
  created() {
    this.$store.dispatch('setUserSession')
  },
  mounted() {
    // this.$store.dispatch('nukeData')
    // console.log('Home Mounted')
    if (this.userSession.isUserSignedIn()) {
      // console.log("user is signed in");
      this.$store.dispatch('setUserProperties').then(() => {
        // this.$store.dispatch('load')
        // console.log('switching to lists...')
        this.$router.push('/maps')
      })
      
    } else if (userSession.isSignInPending()) {
      // console.log("signinpending")
      this.userSession.handlePendingSignIn().then(userData => {
        // console.log("user pending log in finished");
        // this.$store.dispatch('load')
        window.location = window.location.origin
        this.$router.push('/maps')
      });
    }

    // console.log("Login mounted routine finished...");
  },
  methods: {
    signIn() {
      this.$store.dispatch('signIn')
    }
  }
}
</script>

<style scoped>
.card {
  margin: 0 auto; /* Added */
  float: none; /* Added */
  margin-bottom: 10px; /* Added */
}

.displaycard {
  padding:10px;
  width: 100%;
  max-width:300px;
  color:black;
  text-align:left;
  border-radius:15px
}

@keyframes pulse {
  from { transform: scale(1); }
  50% { transform: scale(1.05); }
  to { transform: scale(1); }
}

.fe-pulse-w-pause {
  animation-name: pulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
.fe-pulse-w-pause:hover,
.fe-pulse-w-pause:focus {
  animation-name: unset;
}
</style>